/* eslint arrow-body-style: 0 */
import ConversationView from './Index';
import ViewAllTransaction from './components/ViewAllTransaction'; 
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/payment-dashboard'),
      name: 'payment-dashboard',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: () => {
        return { inboxId: 0 };
      },
    },
    {
      path: frontendURL('accounts/:accountId/payment-dashboard/view-all'),
      name: 'payment-dashboard-viewall',
      roles: ['administrator', 'agent'],
      component: ViewAllTransaction,
      props: () => {
        return { inboxId: 0 };
      },
    },          
  ],
};
